import React, { Component, useState } from "react";
import { signInWithGooglePopup, createUserDocumentFromAuth } from "../utils/firebase/firebase.utils";
import Axios from "axios";

function MsgForm() {
    const [msg, setMsg] = useState("");

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(`Message was ${msg}`);
        setMsg("");

        Axios({
            method: "POST",
            url: "/chat_insert.php",
            data: {
                "msg": msg,
                "email": "test@gmail.com",
                "time": new Date()
            }
        }).then(response => {
            console.log(response);
        }).catch(error => {
            console.log(error);
        });
    }

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Type a message..."/>
            <button type="submit" className="btn btn-secondary">Send</button>
        </form>
    );
}

class ChatSys extends Component {

    state = {loggedIn: false, displayName: null, email: null, chatlog: {data: [{"id":"1","email":"email","msgtime":"00:00:00","message":"Loading..."}]}};

    ChatBox = () => {
        const {chatlog} = this.state;
        console.log("chatlog is", chatlog);
        const messages = chatlog.data || chatlog;
        return (
            <div className="card">
                <div className="card-body" id="chatbox">
                    <p id="chat_test">
                        {
                            messages.map(msg => {
                                return (
                                    <div key={msg.id}>
                                        <b>{msg.email}</b> <i>({msg.msgtime})</i>: {msg.message}
                                    </div>
                                );
                            })
                        }
                    </p>
                </div>
            </div>
        )
    }

    // interval to show chatbox
    componentDidMount() {

        this.interval = setInterval(() => {
            console.log("getting data");
            Axios({
                method: "GET",
                url: "/chat_get2.php"
            }).then(response => {
                console.log("response is", response);
                this.setState({chatlog: response.data});
            }).catch(error => {
                console.log(error);
            });
        }, 1500);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    logInGoogleUser = async () => {
        const {user} = await signInWithGooglePopup();
        const userDocRef = await createUserDocumentFromAuth(user);
        console.log("userDocRef", userDocRef);
        console.log("user", user);
        this.setState({loggedIn: true, displayName: user.displayName, email: user.email});
    }

    render() {
        console.log("rendering");
        const {loggedIn, displayName, email} = this.state;
        return (
            <div>
                <section className="page-section portfolio" id="portfolio">
                    <div className="container">
                        <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Live Chat</h2>
                        <br/>
                        <br/>
                        {!loggedIn &&
                            <div>
                                <p className="text-center">This live chat features Google authentication with SSO (single-sign-on).</p>
                                <p className="text-center">To send messages, please sign in with Google!</p>
                                <button className="btn btn-primary text-center" onClick={this.logInGoogleUser}>Sign in with Google Popup</button>
                            </div>
                        }
                        <br/>
                        {loggedIn &&
                            <div>
                                <p className="text-center">Chatting as <span id="nameBox">{displayName}</span></p>
                                <p className="text-center">Your email is {email}</p>
                            </div>
                        }
                        <this.ChatBox/>
                        <p>Chat sys2</p>
                        {loggedIn &&
                            <MsgForm/>
                        }
                    </div>
                </section>
            </div>
        );
    }
}

export default ChatSys;